<div class="main-container">
  <div class="ui grid">
    <div class="sixteen wide column">
      <h1>
        <i class="setting icon"></i> Settings
      </h1> 
    </div>

    <!-- Sidebar Menu -->
    <div class="sixteen wide mobile four wide tablet four wide computer column settings-side-menu">
      <app-setting-sidebar
              active_tab="account">
      </app-setting-sidebar>
    </div>

    <div class="sixteen wide mobile twelve wide tablet twelve wide computer column settings-main-content">
      <div class="ui top attached tabular menu">
        <div class="item active" data-tab="first" v-if="!isOnSiteUser">Pricing</div>
        <div class="item" data-tab="second">Users</div>
        <div class="item" data-tab="third" v-if="!isOnSiteUser">Integrations</div>
        <div class="item" data-tab="forth" v-if="!isOnSiteUser">Billing</div>
      </div>

      <app-form-error></app-form-error>

      <!-- Tab 1: Pricing -->
      <div class="ui bottom attached tab segment active" data-tab="first" v-if="!isOnSiteUser">
        <form class="ui form settings">
          <h4 class="ui dividing header">
            Job Pricing
          </h4>


          <div class="two fields">
            <div class="field settings eight wide column">
              <div class="ui icon tooltip" data-variation="basic" data-content="Your hourly rate will be used to calculate all of your quotes and invoices by multiplying the time taken for each task. All prices are shown in Australian Dollars (AUD).">
                <label>Hourly Rate*
                  <i class="question circle outline icon"></i>
                </label>
              </div>
              <div class="ui left labeled input">
                <label for="hourlyrate" class="ui label">$</label>
                <input id="hourlyrate" placeholder="0.00" type="text" v-model="settings.hourly_rate" v-bind:class="{ error:validation('hourly_rate') }">
              </div>
            </div>
          </div>

          <div class="field settings">
            <label>Pricing Strategy*</label>
            <div class="pricing-strategy">
              <!-- Regular Pricing card -->
              <div
                class="pricing-strategy__card"
                :class="{ 'pricing-strategy__card--selected': Number(settings.price_structure) === 1 }"
                role="button"
                tabindex="0"
                @click="settings.price_structure = 1"
                @keydown.enter.prevent="settings.price_structure = 1"
                @keydown.space.prevent="settings.price_structure = 1"
              >
                <div class="pricing-strategy__header">
                  <span class="pricing-strategy__icon" aria-hidden="true">
                    <svg width="32" height="26" viewBox="0 0 47 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5 0C28.8208 0 34.4864 2.63542 39.9057 7.66667C42.3613 9.96896 44.5729 12.5053 46.5073 15.2375L47 16.0042L46.5073 16.8188C45.572 18.1445 44.569 19.4239 43.5021 20.6521C46.225 23.7618 46.8452 28.1256 45.0918 31.8371C43.3385 35.5486 39.5302 37.9333 35.3306 37.9495C31.1311 37.9657 27.3035 35.6104 25.5199 31.9125C24.8513 32.0097 24.1761 32.0578 23.5 32.0563C18.1792 32.0563 12.5136 29.3729 7.09434 24.3417C4.64648 22.0497 2.43536 19.53 0.492662 16.8188L0 16.0042L0.492662 15.2375C2.42708 12.5053 4.63874 9.96896 7.09434 7.66667C12.5136 2.63542 18.1792 0 23.5 0ZM3.54709 16.0042C5.7148 18.975 13.9915 29.1812 23.4999 29.1812L24.6823 29.0854C24.599 28.5786 24.566 28.0651 24.5838 27.5521V26.7375L23.4999 26.8333C17.3908 26.8331 12.4334 22.0255 12.4155 16.0837C12.3976 10.142 17.3258 5.30615 23.4348 5.27102C29.5438 5.23589 34.5305 10.0147 34.5848 15.9563C34.593 16.3243 34.5765 16.6924 34.5356 17.0583H35.3731C37.4526 17.0562 39.4886 17.6386 41.2358 18.7354C42.0225 17.8626 42.7625 16.951 43.4527 16.0042C41.285 13.0813 33.0576 2.875 23.4999 2.875C13.9423 2.875 5.7148 13.0813 3.54709 16.0042ZM25.3228 23.7188C24.7271 23.8689 24.1152 23.9493 23.4999 23.9584C20.1877 23.9778 17.1906 22.0521 15.9092 19.0815C14.6279 16.1108 15.3153 12.6817 17.6504 10.3969C19.9854 8.11208 23.5068 7.42273 26.5688 8.65102C29.6309 9.87932 31.6288 12.7827 31.6289 16.0042C31.6391 16.6008 31.5729 17.1964 31.4318 17.7771C28.6233 18.8284 26.4037 20.9872 25.3228 23.7188ZM27.5398 27.5521C27.5398 31.7598 31.0469 35.1708 35.3731 35.1708C39.6993 35.1708 43.2064 31.7598 43.2064 27.5521C43.2064 23.3444 39.6993 19.9333 35.3731 19.9333C31.0469 19.9333 27.5398 23.3444 27.5398 27.5521Z" fill="currentColor"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M34.9825 24.4465C34.8335 24.6221 34.7739 24.8562 34.7739 25.1489C34.7739 25.4416 34.8633 25.6757 35.0123 25.8513C35.1614 26.027 35.4594 26.2026 35.8767 26.4074C36.8602 26.8172 37.6053 27.227 38.0524 27.666C38.5292 28.0757 38.7379 28.6611 38.7379 29.4513C38.7379 30.1831 38.4994 30.7684 38.0226 31.2074C37.6351 31.5879 37.0986 31.8221 36.4728 31.9392V32.9928C36.4728 33.1392 36.3535 33.2562 36.2045 33.2562H35.2806C35.1316 33.2562 35.0123 33.1392 35.0123 32.9928V31.9684C34.2374 31.8806 33.5519 31.5879 33.0453 31.1196C32.5684 30.6806 32.3002 30.066 32.2405 29.2757C32.2405 29.1001 32.3598 28.9831 32.5386 28.9831L34.0586 28.9538C34.2076 28.9538 34.3566 29.0709 34.3566 29.2172C34.3865 29.5977 34.5057 29.8904 34.6845 30.066C34.9229 30.3001 35.221 30.4172 35.5786 30.4172C35.8767 30.4172 36.1151 30.3294 36.2641 30.1538C36.4131 29.9782 36.5026 29.744 36.5026 29.4513C36.5026 29.1294 36.4131 28.866 36.2641 28.6904C36.1151 28.5148 35.8171 28.3392 35.3998 28.1635C34.3865 27.7831 33.6413 27.3733 33.1943 26.9635C32.7472 26.5538 32.5088 25.9684 32.5088 25.1782C32.5088 24.4757 32.7472 23.8904 33.2539 23.4221C33.701 23.0123 34.2672 22.7489 34.9825 22.6318V21.5196C34.9825 21.3733 35.1018 21.2562 35.2508 21.2562H36.1747C36.3237 21.2562 36.4429 21.3733 36.4429 21.5196V22.6611C37.0986 22.8074 37.6649 23.1001 38.0524 23.5684C38.4398 24.0074 38.6485 24.5635 38.7081 25.2367C38.7081 25.4123 38.5889 25.5294 38.41 25.5294L36.8602 25.5587C36.7112 25.5587 36.5622 25.4416 36.5622 25.2952C36.5324 24.9733 36.4429 24.7099 36.2939 24.5343C36.1151 24.3001 35.8767 24.1831 35.5786 24.1831C35.3402 24.1831 35.1316 24.2709 34.9825 24.4465Z" fill="currentColor"/>
                    </svg>
                  </span>
                  <span class="pricing-strategy__title">Regular Pricing</span>
                </div>
                <p class="pricing-strategy__body">
                  Provides the flexibility for you to include your own callout / service fee per quote.
                </p>
              </div>

              <!-- Smart Pricing card -->
              <div
                class="pricing-strategy__card"
                :class="{ 'pricing-strategy__card--selected': Number(settings.price_structure) === 2 }"
                role="button"
                tabindex="0"
                @click="settings.price_structure = 2"
                @keydown.enter.prevent="settings.price_structure = 2"
                @keydown.space.prevent="settings.price_structure = 2"
              >
                <div class="pricing-strategy__header">
                  <span class="pricing-strategy__icon" aria-hidden="true">
                    <svg width="32" height="32" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M41.9958 15.7565C41.7422 7.50887 34.0348 0.606876 24.4512 0.0425622C13.8027 -0.608569 4.87831 6.29342 4.16842 15.1054L4.11771 15.5395C4.11771 17.0154 3.45852 19.2726 2.69792 20.5749C1.8359 21.964 0.973881 23.2662 0.263985 24.2212C-0.445912 25.1328 0.365398 26.3917 1.63307 26.3917H4.11771V34.1618C4.11771 35.7246 5.58821 37.0268 7.46436 37.0268H12.6365V40.9336C12.6365 41.6716 13.4985 42.1925 14.3098 41.932L36.1138 35.5943C36.8744 35.3773 37.3814 34.7696 37.3814 34.075V26.7824C40.3731 23.8306 42.0972 19.9672 41.9958 15.7565ZM23.0314 27.911C15.5268 27.911 9.39125 22.7019 9.39125 16.234C9.39125 9.80953 15.4761 4.55707 23.0314 4.55707C30.536 4.55707 36.6716 9.76612 36.6716 16.234C36.6716 22.6585 30.5867 27.911 23.0314 27.911ZM21.7637 13.1086C21.7637 12.6745 21.8651 12.3272 22.1186 12.0668C22.3722 11.8063 22.7271 11.6761 23.1328 11.6761C23.6398 11.6761 24.0455 11.8497 24.3497 12.197C24.6033 12.4574 24.7554 12.8481 24.8061 13.3256C24.8061 13.5427 25.0596 13.7163 25.3132 13.7163L27.9499 13.6729C28.2542 13.6729 28.457 13.4992 28.457 13.2388C28.3556 12.2404 28.0006 11.4156 27.3414 10.7645C26.6822 10.07 25.7188 9.63587 24.6033 9.41883V7.72588C24.6033 7.50884 24.4004 7.33521 24.1469 7.33521H22.575C22.3215 7.33521 22.1186 7.50884 22.1186 7.72588V9.37542C20.9017 9.54905 19.9382 9.93973 19.1776 10.5475C18.3156 11.242 17.91 12.1102 17.91 13.152C17.91 14.324 18.3156 15.1922 19.0762 15.7999C19.8368 16.4076 21.1045 17.0154 22.8285 17.5797C23.5384 17.8401 24.0455 18.1006 24.299 18.361C24.5526 18.6215 24.7047 19.0122 24.7047 19.4897C24.7047 19.9237 24.5526 20.271 24.299 20.5315C24.0455 20.7919 23.6398 20.9221 23.1328 20.9221C22.5243 20.9221 22.0172 20.7485 21.6116 20.4012C21.3073 20.1408 21.1045 19.7067 21.0538 19.1424C21.0538 18.9253 20.8002 18.7517 20.5467 18.7517L17.9607 18.7951C17.6564 18.7951 17.4536 18.9687 17.4536 19.2292C17.555 20.4012 18.0114 21.3128 18.8227 21.964C19.6847 22.6585 20.851 23.0926 22.1693 23.2228V24.7421C22.1693 24.9592 22.3722 25.1328 22.6257 25.1328H24.1976C24.4511 25.1328 24.654 24.9592 24.654 24.7421V23.1794C25.7188 23.0058 26.6315 22.6585 27.2907 22.0942C28.102 21.443 28.5077 20.5749 28.5077 19.4897C28.5077 18.3176 28.1527 17.4494 27.3414 16.8417C26.5808 16.1906 25.3132 15.5829 23.6398 14.9751C22.9299 14.6713 22.4229 14.4108 22.1693 14.1504C21.9158 13.8899 21.7637 13.5427 21.7637 13.1086Z" fill="#4DA1FF"/>
                    </svg>
                  </span>
                  <span class="pricing-strategy__title">Smart Pricing</span>
                </div>
                <p class="pricing-strategy__body">
                  Hide your flat callout / service fee and incorporate costs into quotes.
                </p>

                <div v-if="Number(settings.price_structure) === 2" class="pricing-strategy__callout">
                  <div class="ui icon tooltip" data-variation="basic" data-content="This fee will be included on all quotes and invoices sent from this account. The fee can be made clearly visible (regular pricing) or incorporated into your total price (smart pricing). All prices are shown in Australian Dollars (AUD).">
                    <label>Callout Fee*
                      <i class="question circle outline icon"></i>
                    </label>
                  </div>
                  <div class="ui left labeled input">
                    <label for="servicerate" class="ui label">$</label>
                    <input id="servicerate" placeholder="0.00" type="text" v-model="settings.callout_fee" v-bind:class="{ error:validation('callout_fee') }">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="two fields">
            <div class="field settings eight wide column">
              <div class="ui icon tooltip" data-variation="basic" data-content="Your standard markup percentage is applied to product buy prices when using Cost + Standard Markup pricing.">
                <label>Product Markup %
                  <i class="question circle outline icon"></i>
                </label>
              </div>
              <div class="ui right labeled input">
                <input id="standardmarginpct" placeholder="30.00" type="text" v-model="settings.standard_margin_pct" v-bind:class="{ error:validation('standard_margin_pct') }">
                <div class="ui label">%</div>
              </div>
            </div>
          </div>

          <div class="two fields pricing-protect-row">
            <div class="field settings eight wide column">
              <app-field-label>Protect pricing details</app-field-label>
              <app-select
                :items="protectPricingOptions"
                :value="settings.protect_pricing_details"
                @selected="onProtectPricingSelected">
              </app-select>
            </div>
            <div
              class="field settings eight wide column"
              :class="{ error: !!pricingPinError }"
              v-if="Number(settings.protect_pricing_details) === 1"
            >
              <app-field-label>4-digit PIN</app-field-label>
              <app-text-input
                variant="pin"
                :model-value="settings.pricing_pin"
                :error="!!pricingPinError"
                @update:model-value="onPricingPinInput">
              </app-text-input>
              <app-field-error :message="pricingPinError" />
              <p v-if="!pricingPinError" class="pricing-pin-help">Protect price details in the Quote Builder.</p>
            </div>
          </div>

          <div class="ui primary button settings-save-btn" v-on:click="saveSettings">
            Save Changes
          </div>

          <h4 class="ui dividing header pricing-discounts-header">
            Discounts
          </h4>
          <div class="two fields pricing-discounts-toolbar">
            <div class="field settings pricing-discounts-copy">
              Below is a list of all discounts available
            </div>
            <div class="field settings pricing-discounts-action">
              <router-link class="ui right floated primary button" to="/settings/discount/new">New Discount</router-link>
            </div>
          </div>
          <table class="ui basic selectable celled padded table pricing-discounts-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Type</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="discount in discounts" :key="discount.id" @click="editDiscount(discount)">
                <td><span class="pricing-discount-pill">{{ discount.type === 'percentage' ? `${Number(discount.amount || 0)}% OFF` : `$${Number(discount.amount || 0)} OFF` }}</span></td>
                <td>{{ discount.description }}</td>
                <td>{{ discount.type === 'percentage' ? 'Percentage' : 'Dollar amount' }}</td>
                <td>{{ discount.type === 'percentage' ? `${Number(discount.amount || 0)}%` : `$${Number(discount.amount || 0).toFixed(2)}` }}</td>
              </tr>
              <tr v-if="discounts.length === 0" class="pricing-discounts-empty-row">
                <td colspan="4" class="center aligned">
                  <div class="empty-state-container">
                    <div class="empty-state-content">
                      <h3 class="empty-state-title">No discounts found</h3>
                      <p class="empty-state-description">Created discounts will appear here</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

        </form>
      </div>

      <!-- Tab 2 -->
      <div class="ui bottom attached tab segment" data-tab="second">
        <form class="ui form settings">
          <h4 class="ui dividing header">
            {{ isOnSiteUser ? 'My Profile' : 'Users' }}
          </h4>
          <div class="two fields" v-if="!isOnSiteUser">
            <div class="field settings">
              Below is a list of all the users who can access your account.
            </div>
            <div class="field settings">
              <a class="ui right floated primary button show-new-user" v-on:click="inviteUser">Invite User</a>
            </div>
          </div>

          <table class="ui basic sortable selectable celled padded table pricing-discounts-table">
            <thead>
            <tr>
              <th class="">Image</th>
              <th class="">Name</th>
              <th class="">Email Address</th>
              <th class="" v-if="!isOnSiteUser">Role</th>
              <th class="" v-if="!isOnSiteUser">Status</th>
              <th class="" v-if="!isOnSiteUser"></th>
            </tr>
            </thead>
            <tbody>
            <template v-for="user in users">
              <tr class="show-view-user" @click="editUser(user)">
                <td>
                  <img src="../../../assets/img/icn_avatar.png" width="32px" height="32px">
                </td>
                <td>{{ user.first_name }} {{ user.last_name }}</td>
                <td>{{ user.email }}</td>
                <td v-if="!isOnSiteUser">{{ user.type_name }}</td>
                <td v-if="!isOnSiteUser">{{ user.status_name }}</td>
                <td v-if="!isOnSiteUser && user.status === 'pending'" class="right aligned" @click.stop>
                  <a href="#" class="ui basic mini button" @click.prevent="resendInvite(user, $event)">Resend</a>
                  <a href="#" class="ui basic mini button" @click.prevent="revokeInvite(user, $event)">Revoke</a>
                </td>
                <td v-else-if="!isOnSiteUser"></td>
              </tr>
            </template>
            </tbody>
            <tfoot>
            </tfoot>
          </table>
        </form>
      </div>

      <!-- Tab 3 -->
      <div class="ui bottom attached tab segment" data-tab="third" v-if="!isOnSiteUser">
        <form class="ui form settings">
          <h4 class="ui dividing header">
            Integrations
          </h4>
          <div class="field">
            Connect 3rd party services to ours and make your life easier!
          </div>

          <!-- 3rd Party Integration List -->
          <div class="ui divided items">

            <!-- Start Xero -->
            <div class="item integration-item">
              <div class="integration ui tiny image">
                <img src="../../../assets/img/icn_xero.svg">
              </div>

              <div class="integration content">
                <div class="integration-information">
                  <h3>Xero</h3>
                  <p>You can connect your Xero account to keep your accounting system in real time sync</p>
                  <p v-if="xeroConnection.connected"><strong>Connected to:</strong> {{ xeroConnection.tenant_name || 'Xero organisation' }}</p>
                  <p v-if="xeroConnection.status === 'error' && xeroConnection.last_error" style="color:var(--color-error);">{{ xeroConnection.last_error }}</p>
                  <p v-if="xeroAccountsScopeWarning" style="color:var(--color-mid-grey); margin-top: 0.5em;">{{ xeroAccountsScopeWarning }}</p>
                </div>

                <div class="integration action">
                  <button
                    v-if="!xeroIsConnected"
                    type="button"
                    class="xero-connect integration.button"
                    aria-label="Sign in with Xero"
                    v-on:click="xeroConnect"
                  ></button>
                  <button
                    v-if="xeroIsConnected"
                    type="button"
                    class="xero-disconnect integration.button"
                    aria-label="Sign out of Xero"
                    v-on:click="xeroDisconnect"
                  ></button>
                </div>

                <div class="integration-subheader" v-if="xeroIsConnected">
                  <h5 class="ui dividing header">Configuration</h5>
                </div>

                <div class="integration-configuration" v-if="xeroIsConnected">
                  <div class="field settings xero-sales-account">
                    <app-field-label>Sales account</app-field-label>
                    <app-select
                      :defaultLabel="'Select Sales Account'"
                      :items="xeroAccounts"
                      :value="settings.addresses.sales_account"
                      @selected="settings.addresses.sales_account = $event.id">
                    </app-select>
                  </div>

                  <div class="ui primary button settings-save-btn" v-if="xeroIsConnected" v-on:click="saveSettings">
                    Save Changes
                  </div>
                </div>

              </div>
            </div>
            <!-- End Xero -->
              <!-- Start ServiceM8 -->
              <div class="item integration-item">
                  <div class="integration ui tiny image">
                      <img src="../../../assets/img/icn_servicem8.png">
                  </div>

                  <div class="integration content">
                      <div class="integration-information">
                          <h3>ServiceM8</h3>
                          <p v-if="$store.getters['company/getIntegrations'].service_m8 === true">Connected. Use <strong>Import from SM8</strong> on the Customers page to sync your clients.</p>
                          <p v-else-if="$store.getters['company/getIntegrations'].service_m8_status === 'error'">Connection needs re-authorisation. Reconnect ServiceM8 to resume syncing.</p>
                          <p v-else>Connect your ServiceM8 account to link jobs to quotes and import customers.</p>
                      </div>

                      <div class="integration action">
                          <div class="ui basic button smardie-btn-secondary" v-if="$store.getters['company/getIntegrations'].service_m8 !== true" v-on:click="serviceM8Connect">
                            {{ $store.getters['company/getIntegrations'].service_m8_status === 'error' ? 'Reconnect' : 'Connect Account' }}
                          </div>
                          <div class="ui button smardie-btn-secondary" v-if="$store.getters['company/getIntegrations'].service_m8 === true" v-on:click="serviceM8Disconnect">Disconnect</div>
                      </div>
                  </div>
              </div>
              <!-- End ServiceM8 -->

          </div>
        </form>
      </div>

      <!-- Tab 4 -->
      <div class="ui bottom attached tab segment" data-tab="forth" v-if="!isOnSiteUser">
        <div class="ui form settings">
          <h4 class="ui dividing header">
            Your Current Plan
          </h4>

          <div class="billing-plan-block">
            <p v-if="billing" class="text-body-medium">
              {{ billing.interval === 'year' ? 'Yearly' : 'Monthly' }}
            </p>

            <p v-else-if="subscriptionStatus && subscriptionStatus.subscription_active" class="text-body-medium">
              {{ subscriptionStatus.subscription_plan === 'standard' ? 'Standard' : (subscriptionStatus.subscription_plan || 'Active') }}
              <span v-if="subscriptionStatus.days_remaining"> — {{ subscriptionStatus.days_remaining }} day(s) left in trial</span>
            </p>

            <template v-if="billing">
              <p v-if="billing.started_at" class="text-body-medium">
                Started {{ formatBillingDate(billing.started_at) }}
              </p>
              <template v-if="billing.next_invoice_at && billing.amount != null">
                <p class="text-body-medium billing-next-invoice-label">Next invoice</p>
                <p class="text-body-medium">
                  ${{ billing.amount.toFixed(2) }} on {{ formatBillingDate(billing.next_invoice_at) }}
                </p>
              </template>
            </template>

            <p v-else-if="!(subscriptionStatus && subscriptionStatus.subscription_active)" class="text-body-medium">
              No active subscription found for this account.
            </p>
          </div>

          <h4 class="ui dividing header billing-payment-history-header">
            Payment History
          </h4>

          <simple-table
            :headers="paymentHistoryHeaders"
            :items="payments"
            :loading="paymentsLoading"
            classes="basic selectable celled padded"
          >
            <template #row="{ item }">
              <td>{{ formatBillingDate(item.date) }}</td>
              <td>{{ item.description }}</td>
              <td>${{ Number(item.amount || 0).toFixed(2) }}</td>
              <td>{{ formatPaymentStatus(item.status) }}</td>
              <td>
                <a
                  v-if="item.receipt_url"
                  :href="item.receipt_url"
                  class="primary"
                  target="_blank"
                  rel="noopener noreferrer"
                  @click.stop
                >View</a>
              </td>
            </template>
          </simple-table>

          <h4 class="ui dividing header">
            Refer a friend
          </h4>
          <p class="text-body-medium">
            Share Smardie with another business. When they subscribe and make their first payment, you both get one month of account credit. Credit applies to your next invoice.
          </p>
          <div class="field settings" v-if="referralLink">
            <app-field-label>Your referral link</app-field-label>
            <app-text-input
              :model-value="referralLink"
              readonly
            />
          </div>
          <button
            type="button"
            class="ui secondary button"
            :disabled="!referralLink"
            @click="copyReferralLink"
          >
            Copy link
          </button>
          <p
            v-if="referralCreditLabel"
            class="text-body-medium"
          >
            {{ referralCreditLabel }}
            <template v-if="billing && billing.next_invoice_at">
              (next invoice {{ formatBillingDate(billing.next_invoice_at) }})
            </template>
          </p>

          <h4
            v-if="referralRows.length || referralLoading"
            class="ui dividing header"
          >
            Your referrals
          </h4>
          <simple-table
            v-if="referralRows.length || referralLoading"
            :headers="referralHeaders"
            :items="referralRows"
            :loading="referralLoading"
            classes="basic selectable celled padded"
          >
            <template #row="{ item }">
              <td>{{ item.referred_company_name }}</td>
              <td>{{ formatReferralStatus(item.status) }}</td>
              <td>{{ formatBillingDate(item.rewarded_at || item.created_at) }}</td>
              <td>{{ formatReferralCredit(item) }}</td>
            </template>
          </simple-table>

          <h4 class="ui dividing header">
            Manage Subscription
          </h4>
          <p>
            If you wish to cancel your subscription please email
            <a href="mailto:support@smardie.com" class="primary">support@smardie.com</a>.
          </p>
        </div>
      </div>

    </div>
  </div>

  <div class="ui segment" v-if="isDev">
    <h4 class="ui header">Development</h4>
    <p class="description">Reset onboarding to go through the welcome → job settings → plan → payment → complete flow again (no new account needed).</p>
    <button type="button" class="ui basic button" @click="resetOnboarding">Reset onboarding</button>
  </div>

</div>
